export default __webpack_public_path__ + "static/eQzfSdkP-5596ec6e6458e11e1a41a12e1f90665e.svg";